import { Injectable } from '@angular/core'
import { BehaviorSubject, fromEvent, Observable, Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class FloatoverService {
  private readonly showView$: Observable<boolean>
  private showView$$ = new BehaviorSubject(false)

  private readonly contentHtml$: Observable<string>
  private contentHtml$$ = new BehaviorSubject('')

  private readonly loading$: Observable<boolean>
  private loading$$ = new Subject<boolean>()

  private readonly position$: Observable<{ x: number; y: number }>
  private position$$ = new BehaviorSubject({ x: 0, y: 0 })

  private currentMousePosition$ = fromEvent(document.body, 'mousemove')
  private currentMousePosition: MouseEvent

  private TAG = 'FloatoverService'

  constructor() {
    this.showView$ = this.showView$$.asObservable()
    this.contentHtml$ = this.contentHtml$$.asObservable()
    this.loading$ = this.loading$$.asObservable()
    this.position$ = this.position$$.asObservable()
    this.currentMousePosition$.subscribe((pos: MouseEvent) => (this.currentMousePosition = pos))
  }

  getFloatoverShowStatus() {
    return this.showView$
  }
  show(x?: number, y?: number) {
    if (!x) x = this.currentMousePosition.clientX
    if (!y) y = this.currentMousePosition.clientY
    this.setPosition(x, y)

    this.showView$$.next(true)
  }
  hide() {
    this.showView$$.next(false)
  }

  getContentHtml() {
    return this.contentHtml$
  }
  setContentHtml(contentHtml: string) {
    this.contentHtml$$.next(contentHtml)
  }

  getLoading() {
    return this.loading$
  }
  setLoading(loading: boolean) {
    this.loading$$.next(loading)
  }

  getPosition() {
    return this.position$
  }

  setPosition(x: number, y: number) {
    this.position$$.next({ x, y })
  }
}
